<template>
  <div class="part table staffs-list">
    <ListSkeleton v-if="loading" />
    <a-table
      v-else
      :loading="loading"
      :columns="columns"
      :dataSource="staffs"
      :rowKey="(record, index) => record._id"
      :scroll="{ x: 1200 }"
      :pagination="pagination"
      @change="change"
    >
      <span slot="avatar" slot-scope="staff">
        <a-avatar shape="square" :size="30" :src="staff.avatar" icon="user" />
      </span>

      <span slot="active" slot-scope="staff">
        <span class="dot" :class="{ active: staff.active }"></span>
      </span>

      <span slot="department" slot-scope="department">
        {{ department | DEPARTMENT_ }}
      </span>

      <span slot="job_title" slot-scope="job_title">
        {{ job_title | JOB_TITLE_ }}
      </span>

      <span slot="created_at" slot-scope="created_at">
        {{ created_at | moment('l') }}
      </span>

      <span slot="actions" slot-scope="staff">
        <a-button type="primary" class="ml-1" @click="onEdit(staff._id)" size="small" icon="edit">Edit</a-button>
      </span>
    </a-table>
  </div>
</template>

<script>
import { ListSkeleton } from '@/components/reno/skeleton'
import router from '@/router'
import store from '@/store'

const KEY = 'staffs'

export default {
  components: {
    ListSkeleton,
  },
  name: 'table-staffs',
  props: ['staffs', 'pagination', 'loading'],
  data() {
    return {
      columns: [
        {
          title: 'Avatar',
          key: 'avatar',
          width: 80,
          fixed: 'left',
          scopedSlots: { customRender: 'avatar' },
        },
        {
          title: 'Username',
          dataIndex: 'username',
          key: 'username',
          width: 120,
          fixed: 'left',
          sorter: (a, b) => {
            return a.username.localeCompare(b.username)
          },
        },
        {
          title: 'Status',
          key: 'active',
          width: 90,
          scopedSlots: { customRender: 'active' },
        },
        {
          title: 'Display Name',
          dataIndex: 'display_name',
          key: 'display_name',
          width: 160,
          sorter: (a, b) => {
            return a.display_name.localeCompare(b.display_name)
          },
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          width: 180,
          ellipsis: true,
          sorter: (a, b) => {
            return a.email.localeCompare(b.email)
          },
        },
        {
          title: 'Phone',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: 'Department',
          dataIndex: 'department',
          key: 'department',
          width: 150,
          scopedSlots: { customRender: 'department' },
        },
        {
          title: 'Job Title',
          dataIndex: 'job_title',
          key: 'job_title',
          scopedSlots: { customRender: 'job_title' },
        },
        {
          title: 'Creation',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: { customRender: 'created_at' },
        },
        {
          title: 'Actions',
          key: 'actions',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'actions' },
        },
      ],
    }
  },
  methods: {
    onEdit(id) {
      router.push({ name: 'staff-detail', params: { id } })
    },
    change: (pagination, filters, sorter) => {
      store.dispatch('staffs/updateQuery', { key: KEY, query: { pagination, filters, sorter } })
    },
  },
}
</script>

<style lang="scss" scoped>
.table.staffs-list {
  .dot {
    display: inline-block;
    height: 0.86rem;
    width: 0.86rem;
    background: #ff0000;
    border-radius: 20px;
    margin-left: 0.53rem;
    vertical-align: middle;
    position: relative;
    top: -2px;

    &.active {
      background: #00b44b;
    }
  }
}
</style>
